import Textarea from "@/components/common/Textarea.vue";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
    name: 'ActionComment',

    components: {
        Textarea
    },

    data () {
        return {
            comment: null,
            object: {},
            title: ''
        }
    },

    setup: () => ({ v$: useVuelidate() }),
    validations () {
        return {
            comment: { required }
        }
    },

    methods: {
        async show (el) {
            this.v$.$reset();
            this.comment = null;
            this.object = this.BasicHelper.cloneObject(el);
            this.title = this.object.status === '0' ? this.$t('object.actionComment.title-turn-on') : this.$t('object.actionComment.title-turn-off');
            this.$refs['modal-window'].show();
        },

        async submit () {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                return;
            }

            this.$refs['modal-window'].hide();
            this.object.comment = this.comment;
            this.$emit('confirm', this.object);
        },

        close () {
            this.$refs['modal-window'].hide();
        }
    }
}